var _path, _path2, _path3, _path4, _path5, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.8789 101.332H46.709C41.7268 101.332 37.6875 97.2923 37.6875 92.31C37.6875 87.3278 41.7268 83.2885 46.709 83.2885H88.1088C92.952 83.2885 96.8771 79.3634 96.8771 74.5202C96.8771 69.677 92.952 65.7518 88.1088 65.7518H46.709C41.7268 65.75 37.6875 61.7108 37.6875 56.7285C37.6875 51.7463 41.7268 47.707 46.709 47.707H96.8789",
    stroke: "#004F9F",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.993 51.644H97.9006C97.2482 51.644 96.7188 51.1146 96.7188 50.4621V44.9006C96.7188 44.2482 97.2482 43.7188 97.9006 43.7188H105.993C106.646 43.7188 107.175 44.2482 107.175 44.9006V50.4639C107.175 51.1163 106.646 51.644 105.993 51.644Z",
    stroke: "#004F9F",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.968 49.7083H107.344V45.6602H109.968C110.613 45.6602 111.137 46.1842 111.137 46.8295V48.5372C111.137 49.1843 110.613 49.7083 109.968 49.7083Z",
    stroke: "#004F9F",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.993 105.103H97.9006C97.2482 105.103 96.7188 104.573 96.7188 103.921V98.3576C96.7188 97.7052 97.2482 97.1758 97.9006 97.1758H105.993C106.646 97.1758 107.175 97.7052 107.175 98.3576V103.921C107.175 104.573 106.646 105.103 105.993 105.103Z",
    stroke: "#004F9F",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.968 103.164H107.344V99.1172H109.968C110.613 99.1172 111.137 99.6413 111.137 100.287V101.994C111.137 102.64 110.613 103.164 109.968 103.164Z",
    stroke: "#004F9F",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 147,
    height: 147,
    rx: 73.5,
    stroke: "#004F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg3);
export default __webpack_public_path__ + "static/media/img3.53d07bfc54e72071cb50f78b5a5dd511.svg";
export { ForwardRef as ReactComponent };